// CvcSection.js
import React, { Component } from 'react';
import { CardCVCElement } from 'react-stripe-elements';

import styles from '../../Form/themeV3.scss';

class CvcSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ready: false,
        };
        this.handleReady = this.handleReady.bind(this);
    }

    handleReady() {
        this.setState({ ready: true });
    }

    render() {
        const { error, onChange, style, themeV3, disabled } = this.props;
        const { ready } = this.state;

        return (
            <div className={`col-6`}>
                <div className={`form-group form-group-xl ${error && 'is-invalid'} ${themeV3 ? styles.themeV3 : ''}`}>
                    <label>{!themeV3 && 'CVV'}</label>
                    <div className={`${styles.inputWrapper} input-wrapper`}>
                        <CardCVCElement
                            className={`${styles.formControl} form-control`}
                            onChange={onChange}
                            style={style}
                            placeholder="CVV"
                            onReady={this.handleReady}
                            disabled={disabled || !ready}
                        />
                        {themeV3 && <label>CVV</label>}
                        <div className="error-indicator" />
                    </div>
                    {error && <div className="invalid-feedback">{error}</div>}
                </div>
            </div>
        );
    }
}

export default CvcSection;
